import type { CriminalDocumentRow } from '../../../types/criminalCaseRequest';
import { DocumentUploadRow } from '../../../components/wizard/DocumentUploadRow';

type Props = {
  doc: CriminalDocumentRow;
  uploading: boolean;
  reasonError?: string;
  onUploadClick: () => void;
  onPreview: () => void;
  onRemove: () => void;
  onReasonChange: (reason: string) => void;
};

/** @deprecated Import DocumentUploadRow from components/wizard/DocumentUploadRow */
export function CriminalDocumentUploadRow(props: Props) {
  return <DocumentUploadRow {...props} idPrefix="crim" />;
}
